export default __webpack_public_path__ + "static/media/verified-supplier.f7dbb498.svg";